<app-tool-loader [isLoading]="isLoading()" positionUnset="true">
  <div class="flex flex-col w-full h-full min-h-0 overflow-hidden p-1">
    <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

    <p-dialog [draggable]="false" [(visible)]="isWellConfigMissing" [closable]="false" appendTo="self">
      <i style="font-size: 10px" class="pi pi-exclamation-circle pr-1"></i> <label>Well Configuration Missing: Please specify at
      least one string</label>
      <br />
      <br />
    </p-dialog>

    <p-dialog [draggable]="false" [visible]="packerData && packerData.isFullyCemented" [closable]="false" appendTo="self">
      <i style="font-size: 10px" class="pi pi-exclamation-circle pr-1"></i> <label>String is fully cemented</label> <br />
      <br />
    </p-dialog>

    <div class="flex flex-1 min-h-0 overflow-hidden">
      <!-- Orderlist Section -->
      <div class="z-[2] flex-[0.3] min-w-[150px] min-h-0 flex-shrink overflow-auto">
        <p-listbox 
          [scrollHeight]="''"
          [options]="packerData?.packers"
          optionLabel="type" 
          (onChange)="onPackerSelect($event)"
          cdkDropList 
          (cdkDropListDropped)="drop($event)"
          [(ngModel)]="selectedPacker[0]">
    
          <ng-template #header>
            <div class="w-full">
              <div class="flex justify-start items-center space-x-2">
                <p-button outlined size="small" severity="primary" [disabled]="packerData?.packers?.length < 2"
                  title="Sort packers Bottom Up" icon="pi pi-sort-amount-up-alt" (onClick)="onSortUp()"
                ></p-button>
    
                <p-button outlined size="small" severity="primary" [disabled]="packerData?.packers?.length < 2"
                  title="Sort packers Top Down" icon="pi pi-sort-amount-down-alt" (onClick)="onSortDown()">
                </p-button>
    
                <p-button class="outlined-button" size="small" severity="success" outlined="true" label="Add" 
                  title="Add Packer"
                  (onClick)="onAddPacker()">
                </p-button>
    
                <i
                  pTooltip="Packers are set in the order listed below"
                  tooltipPosition="right"
                  class="pi pi-info-circle cursor-help inline-block relative z-[2]"
                ></i>
              </div>
              @if (packerOrderLabel) {
                <p class="text-sm">{{ packerOrderLabel }}</p>
              }
            </div>
          </ng-template>
    
          <ng-template let-packer #item>
            <div class="flex w-full items-center" 
              cdkDrag
              [cdkDragDisabled]="selectedPacker?.['measuredDepth'] === null"
            >
              <div class="flex-1">{{ packer.name }}</div>
              <div>
                <i
                  class="pi pi-trash !text-red-400" 
                  pTooltip="Delete Packer" 
                  (click)="onDeletePacker(packer)">
                </i>
              </div>
            </div>
          </ng-template>
        </p-listbox>
      </div>
    
      <!-- Main Content Section -->
      @if (userUnits) {
        <div class="flex-[0.7] min-w-0 min-h-0 p-2 overflow-hidden">
            <app-packer-data
              [packer]="selectedPackerDetails$ | async" 
              (packerUpdate)="savePacker($event)"
              [userUnits]="userUnits" 
              [disabled]="packerData?.packers?.length < 1"
              [packersStore]="packersStore" 
              [errorMessage]="packerErrorMessage"
              [currentString]="selectedString"
              [packerIndex]="selectedPackerIndex"
              class="block h-full min-h-0"
            ></app-packer-data>
        </div>
      }
    </div>
  </div>
</app-tool-loader>